import type { OnlyFansMessage } from '@api'
import { format, isThisYear, isYesterday } from 'date-fns'
import { useUnit } from 'effector-react'

import { Button } from '@/components/ui/button.tsx'
import { SafeFormattedText } from '@/components/ui/safe-formatted-message'
import { Separator } from '@/components/ui/separator.tsx'
import { $activeChatDetails } from '@/models/chattingUI/chats/chats.ts'
import { ChatMediaCounter } from '@/modules/chatting/ui/chat-window/chat-media-counter'

interface Props {
  message?: OnlyFansMessage | null
  onViewMessageClick: (m: OnlyFansMessage) => void
  canView: boolean
}

export const MessageReplyPreview = ({
  message,
  onViewMessageClick,
  canView,
}: Props) => {
  const activeChat = useUnit($activeChatDetails)

  if (!message) {
    return null
  }

  return (
    <div className="mb-2 rounded bg-primary-50 p-1.5 dark:bg-primary-800">
      <div className="px-2">
        <div className="flex items-center">
          <span className="text-xs font-medium">
            {message.fromUser.id === activeChat?.withUser?.id
              ? activeChat?.withUser?.name
              : (message.authorName ?? 'Unknown')}
            ,{' '}
            {isYesterday(new Date(message.createdAt))
              ? 'Yesterday'
              : format(
                  new Date(message.createdAt),
                  `MMM dd ${!isThisYear(new Date(message.createdAt)) ? ', yyyy' : ''}`,
                )}
            {', '}
            {format(new Date(message.createdAt), 'hh:mm a')}
          </span>
        </div>
        <div className="my-2">
          <ChatMediaCounter message={message} />
        </div>
        {message.text && (
          <>
            <Separator className="my-1.5" />
            <p className="line-clamp-4 overflow-hidden text-sm">
              {message.text && (
                <SafeFormattedText
                  text={message.text}
                  plain
                />
              )}
            </p>
          </>
        )}
      </div>
      {canView && (
        <Button
          onClick={() => onViewMessageClick(message)}
          size="sm"
          variant="ghost"
          className="mt-1.5"
        >
          View Message
        </Button>
      )}
    </div>
  )
}
